import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import notification from './notificationModule/reducer';
import multiUser from './multiUserModule/reducer';
import location from './locationModule/reducer';
import loading from './loadingModule/reducer';
import onboarding from './onboardingModule/reducer';
import app from './appModule/reducer';
import user from './userModule/reducer';
import tracking from './trackingModule/reducer';

import { history } from '../routes/utils';

export const makeRootReducer = (injectedReducers = {}) => {
  const rootReducer = combineReducers({
    [location.name]: location.reducer,
    [loading.name]: loading.reducer,
    [multiUser.name]: multiUser.reducer,
    [notification.name]: notification.reducer,
    [onboarding.name]: onboarding.reducer,
    [app.name]: app.reducer,
    [user.name]: user.reducer,
    [tracking.name]: tracking.reducer,

    ...injectedReducers,
  });

  const mergeWithRouterState = connectRouter(history);
  return mergeWithRouterState(rootReducer);
};

// export const injectReducer = (store, { key, reducer }) => {
//   store.asyncReducers[key] = reducer; //eslint-disable-line
//   store.replaceReducer(makeRootReducer(store.asyncReducers));
// };

export default makeRootReducer;
